import { styled, TextField, TextFieldProps } from "@mui/material";
import React from "react";

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  "& .MuiOutlinedInput-input": {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "10px",
    border: "1px solid",
    borderColor: "#bbb",
    placeholderStyle: 50,
  },
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.secondary[300],
  },
  
  
}));

const LightTextField = (props: TextFieldProps) => {
  return (
    <StyledTextField
      variant="outlined"
      {...props}
    />
  );
};

export default LightTextField;
